import { Link } from 'react-router-dom';
import { Container } from './styles/Container.style';
export default function About() {
	return (
		<>
			<Container>
				<h1>About</h1> <Link to='/'>Go Back Home</Link>
			</Container>
		</>
	);
}
